import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { FilterColumn, FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { IFilter } from "../interface/filter";

export class Filter<T> implements IFilter<T> {
  columnsToSearch: FilterColumn[];
  conditions: { [id: string]: (o: T, f: string) => boolean };
  columnActive: string = "";
  constructor(
    conditions: Condition<T>,
    columns: ListColumn[],
    selected: boolean = true
  ) {
    this.conditions = conditions;
    this.initColumnsSearch(columns, selected);
  }

  initColumnsSearch(columns: ListColumn[], selected: boolean = true) {
    this.columnsToSearch = columns
      .filter((f) => f.useFilter && f.useFilter == true)
      .map((m) => {
        return { name: m.name, property: m.property, selected: selected };
      });
  }

  setColumnActive(column: string) {
    this.columnActive = column;
  }

  setDataTable(data: T[], table: CardTableComponent) {
    let filterdata = data;
    if (this.columnActive != "")
      filterdata = filterdata.filter((f) => f[this.columnActive]);
    table.setData(filterdata);
  }

  filterdata(e: FilterEvent, data: T[], table: CardTableComponent) {
    let filterdata = data;

    if (this.columnActive != "" && !e.showInactive)
      filterdata = filterdata.filter((f) => f[this.columnActive]);

    if (e != null) {
      let filtro = e.filter.toLocaleLowerCase().trim();
      if (filtro.length > 0 && e.columns.length > 0) {
        var temp: ((o: any, f: string) => boolean)[] = [];
        for (let index = 0; index < e.columns.length; index++) {
          const element = e.columns[index];
          if (this.conditions[element]) temp.push(this.conditions[element]);
        }
        filterdata = filterdata.filter((f) => temp.some((c) => c(f, filtro)));
      }
    }

    table.setData(filterdata);
  }
}
